// tslint:disable:max-line-length

import React from 'react';

export const ActionSort = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M3,0v12H0l4,4l4-4H5V0H3z" />
      <path d="M13,16V4h3l-4-4L8,4h3v12H13z" />
    </svg>
  );
};
